import { styled } from 'core'

export const ContainerTooltip = styled('div')`
    cursor: pointer;
`
